import { useEffect, useRef } from 'react';

const FunctionsShowOnlyActiveCardOrAnnotationStylebar = () => {
  const lastActiveContainerIdRef = useRef(null);

  useEffect(() => {
    const hideAllToolbars = () => {
      document.querySelectorAll('.ql-toolbar').forEach(toolbar => {
        // Check if the toolbar is inside #savedStylesContainer and skip hiding it
        if (!toolbar.closest('#savedStylesContainer')) {
          toolbar.style.visibility = 'hidden';
        }
      });
    };

    const handleContainerClick = (container) => {
      hideAllToolbars();
      const toolbar = container.querySelector('.ql-toolbar');
      if (toolbar) {
        toolbar.style.visibility = 'visible';
        lastActiveContainerIdRef.current = container.id;
      }
    };

    const addClickListeners = () => {
      const allContainers = document.querySelectorAll('[id^="cardContainer-"], [id^="annotationContainer-"]');
      allContainers.forEach(container => {
        if (!container.dataset.listenerAttached) {
          container.addEventListener('click', () => handleContainerClick(container));
          container.dataset.listenerAttached = 'true';
        }
      });
    };

    const showInitialToolbar = () => {
      const cardContainers = Array.from(document.querySelectorAll('[id^="cardContainer-"]'));
      const containersWithIds = cardContainers.map(container => {
        const idMatch = container.id.match(/^cardContainer-(\d+)-(\d+)$/);
        if (idMatch) {
          return {
            element: container,
            rowId: parseInt(idMatch[1], 10),
          };
        }
        return null;
      }).filter(Boolean);

      const lowest = containersWithIds.reduce((acc, curr) => {
        return acc.rowId < curr.rowId ? acc : curr;
      }, containersWithIds[0]);

      hideAllToolbars();

      if (lowest && lowest.element) {
        const toolbar = lowest.element.querySelector('.ql-toolbar');
        if (toolbar) {
          toolbar.style.visibility = 'visible';
          lastActiveContainerIdRef.current = lowest.element.id;
        }
      }
    };

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const elements = [];

            if (
              node.id?.startsWith('cardContainer-') ||
              node.id?.startsWith('annotationContainer-')
            ) {
              elements.push(node);
            }

            const nestedContainers = node.querySelectorAll?.('[id^="cardContainer-"], [id^="annotationContainer-"]');
            if (nestedContainers?.length) {
              elements.push(...nestedContainers);
            }

            elements.forEach(container => {
              const toolbar = container.querySelector('.ql-toolbar');

              if (toolbar) {
                toolbar.style.visibility = 'hidden';
              }

              if (!container.dataset.listenerAttached) {
                container.addEventListener('click', () => handleContainerClick(container));
                container.dataset.listenerAttached = 'true';
              }

              if (container.id === lastActiveContainerIdRef.current) {
                setTimeout(() => {
                  const maybeToolbar = container.querySelector('.ql-toolbar');
                  if (maybeToolbar) {
                    hideAllToolbars();
                    maybeToolbar.style.visibility = 'visible';
                  }
                }, 50);
              }
            });
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    showInitialToolbar();
    addClickListeners();

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
};

export default FunctionsShowOnlyActiveCardOrAnnotationStylebar;
